import { render, staticRenderFns } from "./Integracao-rnds.vue?vue&type=template&id=98fee1ae&"
import script from "./Integracao-rnds.vue?vue&type=script&lang=js&"
export * from "./Integracao-rnds.vue?vue&type=script&lang=js&"
import style0 from "./Integracao-rnds.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports